import React from 'react'
import { Box, Text, UnorderedList, ListItem, Heading } from '@chakra-ui/react'
import { useDispatch, useSelector } from 'react-redux'
import { setChangelogBoxOpen } from '../../../redux/actions/map.actions'

import CustomDrawer from '../../Drawer'

export default function ChangelogBox() {
  const dispatch = useDispatch()
  const isChangelogBoxOpen = useSelector(
    (state) => state.mapStates.isChangelogBoxOpen,
  )
  console.log(isChangelogBoxOpen)
  const btnRef = React.useRef()

  const onClose = () => {
    dispatch(setChangelogBoxOpen(false))
  }
  return (
    <>
      <CustomDrawer
        isOpen={isChangelogBoxOpen}
        title="Changelog"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <Box>
          <Box>
            <Heading as="h4" size="md" mb={6}>
             Changelog
            </Heading>
            <Text fontWeight={'bolder'}>(2022-05-25)</Text>
            <UnorderedList ml={10} py={2}>
              <ListItem>
                Living Planet Symposium (Bonn, Germany) - Poster Introduction of
                GeoSES InSAR monitoring results
              </ListItem>
            </UnorderedList>
          </Box>
          <Box>
            <Text fontWeight={'bolder'}>(2022-05-26)</Text>
            <UnorderedList ml={10} py={2}>
              <ListItem>
                {' '}
                <Text
                  as="a"
                  href="https://meetingorganizer.copernicus.org/EGU22/session/43343#Presentations"
                  color={'blue.500'}
                  target="_blank"
                >
                  EGU 2022 (Vienna, Austria){' '}
                </Text>
                - Oral Presentation of GeoSES InSAR monitoring results
              </ListItem>
            </UnorderedList>
          </Box>
        </Box>
      </CustomDrawer>
    </>
  )
}
